import React from 'react'
import FormReport from "../../../../../../components/pages/FormReport";
import { useFetch } from '../../../../../../hooks/useFetch';

export default () => { // eslint-disable-line

    return (
        <FormReport
            title={'Import PJT Reports'}
            repType={'daily'}
            url={"/api/v1/report_import_pjt"}
            FetchComponent={useFetch}
        />
    )
}